import { CoreScoreNames } from '../../../common/enum/scores/core-score-name.enum';

export interface GetSelfDigitalIntensityScoreResponseDto {
  value: string;
  unformattedValue: number;
  allTimeAverage: string;
  max: string;
  deviationFromAveragePercentage: string;
  name: CoreScoreNames;
}
